import {
  GraduationCap,
  Sparkles,
  Award,
  Zap,
  Globe,
  Briefcase,
  Rocket,
  ChevronRight,
  Heart,
  Cpu,
  TrendingUp,
  Flame,
} from "lucide-react";

import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
import { motion } from "framer-motion";
import BlockAcademicOffer from "../../components/BlockAcademicOffer";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/61852126-e432-4e54-ad68-3608ee99cbd4" +
  "?include=field_imagen_portada.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6," +
  "field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,,field_bloque15,,field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function DecideSerMas() {
  const blockStyles = `
    bg-white rounded-2xl p-8 shadow-lg
    hover:-translate-y-1 transition-all duration-300

    [&_h3]:text-4xl
    [&_h3]:font-black
    [&_h3]:text-[#004270]
    [&_h3]:leading-none
    [&_h3]:mb-4

    [&_h4]:text-2xl
    [&_h4]:font-bold
    [&_h4]:text-[#004270]
    [&_h4]:mb-3

    [&_p]:text-slate-600
    [&_p]:leading-7
    [&_p_strong]:text-[#004270]
    [&_p_strong]:font-semibold
  `;

  const DataDisplay = ({ data }) => {
    if (!data) return null;

    const testimoniosPrendho = [
      {
        content: data.bloque16,
      },
      {
        content: data.bloque17,
      },
      {
        content: data.bloque18,
      },
      {
        content: data.bloque19,
      },
      {
        content: data.bloque20,
      },
    ];

    const bloques = [
      { content: data.bloque1, icon: Award },
      { content: data.bloque2, icon: Zap },
      { content: data.bloque3, icon: GraduationCap },
      { content: data.bloque4, icon: Globe },
      { content: data.bloque5, icon: Briefcase },
      { content: data.bloque6, icon: Rocket },
    ];

    const lineasEstrategicas = [
      {
        id: 1,
        content: data.bloque8,
        icon: Heart,
        color: "from-blue-500 to-indigo-600",
      },
      {
        id: 2,
        content: data.bloque9,
        icon: Cpu,
        color: "from-amber-500 to-yellow-600",
      },
      {
        id: 3,
        content: data.bloque10,
        icon: Globe,
        color: "from-emerald-500 to-teal-600",
      },
      {
        id: 4,
        content: data.bloque11,
        icon: TrendingUp,
        color: "from-cyan-500 to-blue-600",
      },
    ];
    return (
      <div>
        {/* HERO */}
        <section>
          <div className="relative overflow-hidden pt-12 pb-24 lg:pt-20 lg:pb-32 bg-gradient-to-br from-white via-slate-50 to-[#004270]/5">
            <div className="absolute inset-0 opacity-40 pointer-events-none">
              <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <pattern
                    id="hero-grid"
                    width="40"
                    height="40"
                    patternUnits="userSpaceOnUse"
                  >
                    <path
                      d="M 40 0 L 0 0 0 40"
                      fill="none"
                      stroke="rgba(0,66,112,0.06)"
                      strokeWidth="1"
                    />
                  </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#hero-grid)" />
              </svg>
            </div>

            <div className="max-w-7xl mx-auto px-4 relative z-10">
              <div className="max-w-5xl m-auto text-center space-y-8 mt-10">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  className="flex items-center justify-center gap-2 text-[#015e9e] font-semibold text-sm uppercase"
                >
                  <Sparkles className="w-4 h-4 text-[#febe10]" />
                  <span>La Universidad más Innovadora del Ecuador</span>
                </motion.div>

                <div
                  className="
                    [&_h2]:text-5xl [&_h2]:font-extrabold [&_h2]:text-[#004270] [&_h2]:text-center
                    [&_h3]:text-6xl [&_h3]:font-black [&_h3]:text-center
                    [&_h3]:bg-gradient-to-r [&_h3]:from-[#004270] [&_h3]:via-[#015e9e] [&_h3]:to-[#febe10]
                    [&_h3]:bg-clip-text [&_h3]:text-transparent [&_h3]:m-0 [&_h3]:p-0 [&_h3]:pb-10
                    [&_p]:text-center [&_p]:max-w-3xl [&_p]:mx-auto
                    [&_p]:text-slate-500 [&_p]:leading-7

                     [&_h4]:inline-flex
    [&_h4]:items-center
    [&_h4]:justify-center
    [&_h4]:rounded-full
    [&_h4]:bg-[#febe10]
    [&_h4]:px-4
    [&_h4]:py-2
    [&_h4]:text-xs
    [&_h4]:font-bold
    [&_h4]:uppercase
    [&_h4]:tracking-wider
    [&_h4]:text-[#004270]
    [&_h4]:shadow-lg
    [&_h4]:border-2
    [&_h4]:border-white
    [&_h4]:mx-1
    [&_h4]:mb-4 [&_h4]:mt-10
                  "
                  dangerouslySetInnerHTML={{ __html: data.texto_portada }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* BLOQUES */}
        <section className="max-w-7xl mx-auto px-6 py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {bloques.map(({ content, icon: Icon }, index) => (
              <div key={index} className="group relative">
                <div className="absolute left-1/2 -translate-x-1/2 -top-7 z-10">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#febe10] to-[#ffd84d] flex items-center justify-center shadow-lg">
                    <Icon className="w-8 h-8 text-[#004270]" />
                  </div>
                </div>

                <div
                  className={`${blockStyles} pt-14 h-full border border-slate-100 text-center pb-10`}
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              </div>
            ))}
          </div>
        </section>

        <section
          id="pilares"
          className="py-24 bg-gradient-to-b from-slate-50 to-white"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Header */}
            <div className="text-center space-y-4 max-w-3xl mx-auto">
              <h2 className="text-xs font-black uppercase tracking-widest text-[#febe10]">
                Líneas estratégicas, misionalidad y visión
              </h2>
              <div
                className="
                  

                    [&_h3]:text-6xl [&_h3]:font-black [&_h3]:text-center
                    [&_h3]:bg-gradient-to-r [&_h3]:from-[#004270] [&_h3]:via-[#015e9e] [&_h3]:to-[#febe10]
                    [&_h3]:bg-clip-text [&_h3]:text-transparent [&_h3]:m-0 [&_h3]:p-0 [&_h3]:pb-10
                    [&_p]:text-center [&_p]:max-w-3xl [&_p]:mx-auto
                    [&_p]:text-slate-500 [&_p]:leading-7
                  "
                dangerouslySetInnerHTML={{ __html: data.bloque7 }}
              />
            </div>

            {/* Pillars Cards Grid */}
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
              {lineasEstrategicas.map((pilar, index) => {
                const Icon = pilar.icon;
                return (
                  <div
                    key={pilar.id}
                    className="bg-white border border-slate-100 rounded-3xl p-6 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group flex flex-col justify-between"
                  >
                    <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-[#004270] to-[#febe10] opacity-0 group-hover:opacity-100 transition-opacity"></div>

                    <div className="space-y-4">
                      <div className="w-12 h-12 rounded-2xl bg-[#004270]/5 flex items-center justify-center group-hover:bg-[#febe10]/15 transition-all">
                        <Icon className="w-6 h-6 text-[#004270] group-hover:text-[#004270]" />
                      </div>

                      <div
                        dangerouslySetInnerHTML={{ __html: pilar.content }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Misión y Visión Direct Cards */}
            <div className="grid md:grid-cols-2 gap-8 mt-12">
              <div className="bg-gradient-to-r from-[#004270] to-[#01355a] rounded-3xl p-8 text-white relative overflow-hidden">
                <div className="absolute -right-12 -bottom-12 w-48 h-48 bg-white/5 rounded-full blur-xl"></div>
                <div
                  className="[&_p]:text-white [&_h2]:text-[#febe10] [&_h2]:text-lg [&_h2]:uppercase"
                  dangerouslySetInnerHTML={{ __html: data.bloque12 }}
                />
              </div>
              <div className="bg-white border border-slate-150 rounded-3xl p-8 relative overflow-hidden">
                <div className="absolute -right-12 -bottom-12 w-48 h-48 bg-[#febe10]/5 rounded-full blur-xl"></div>
                <div
                  className="[&_p]:text-[#004270] [&_h2]:text-[#febe10] [&_h2]:text-lg [&_h2]:uppercase"
                  dangerouslySetInnerHTML={{ __html: data.bloque13 }}
                />
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div
              className="[&_p]:text-slate-600 max-w-4xl m-auto text-center  "
              dangerouslySetInnerHTML={{ __html: data.bloque14 }}
            />
          </div>

          <div className="[&_h2]:hidden [&_h3]:hidden [&_p]:hidden">
            <BlockAcademicOffer></BlockAcademicOffer>{" "}
          </div>
        </section>

        {/* INNOVATION & SUSTAINABLE CAMPUS GRID */}
        <section id="innovacion" className="py-24 bg-slate-50 mt-10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Section Header */}
            <div className="text-center space-y-4 max-w-3xl mx-auto mb-16">
              <h2 className="text-xs font-black uppercase tracking-widest text-[#febe10]">
                Liderazgo & Ecosistema
              </h2>
              <div
                className="[&_p]:text-slate-600 max-w-4xl m-auto text-center  "
                dangerouslySetInnerHTML={{ __html: data.bloque15 }}
              />
            </div>

            {/* Grid Cards of Innovations */}
            <div className="grid lg:grid-cols-3 gap-8">
              {testimoniosPrendho.map((item, idx) => (
                <div
                  key={idx}
                  className="bg-white border border-slate-100 rounded-3xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col justify-between group"
                >
                  <div className="space-y-4">
                    <div
                      className="
    [&_h4]:inline-block
    [&_h4]:w-fit
    [&_h4]:rounded-full
    [&_h4]:bg-yellow-300
    [&_h4]:px-3
    [&_h4]:py-1
    [&_h4]:text-xs
    [&_h4]:font-semibold
    [&_h4]:uppercase
    [&_h4]:tracking-wide
    [&_h4]:text-slate-900

    [&_h2]:mt-4
    [&_h2]:text-4xl
    [&_h2]:font-bold
    [&_h2]:leading-tight

    [&_p]:mt-3
    [&_p]:text-lg
    [&_p]:text-slate-600

    [&_h3]:inline-flex
    [&_h3]:items-center
    [&_h3]:rounded-lg
    [&_h3]:bg-slate-100
    [&_h3]:px-4
    [&_h3]:py-2
    [&_h3]:font-medium
     [&_h3]:text-sm
         [&_h3]:my-2
  "
                      dangerouslySetInnerHTML={{ __html: item.content }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    );
  };

  return (
    <DataFetcherTemplateHome url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome>
  );
}

export default DecideSerMas;
